import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureBlobStoreWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/azure-blob-store-write-settings';
import { storeWriteSettingsAdapts, StoreWriteSettingsAdapter } from './store-write-settings.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobStoreWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts,
        blockSizeInMB: '*',
        metadata: '*'
    }
})
export class AzureBlobStoreWriteSettingsAdapter extends StoreWriteSettingsAdapter<
    AzureBlobStoreWriteSettings,
    Model.StoreWriteSettings
> {
    protected override async _toResource(model: AzureBlobStoreWriteSettings): Promise<Model.StoreWriteSettings> {
        const result: Model.StoreWriteSettings = await super._toResource(model);
        StoreWriteSettingsAdapter.toStoreWriteSettingsResource(model, result);
        this._commonPropsToResource(result, model);
        return result;
    }

    protected override async _toModel(
        resource: Model.StoreWriteSettings,
        copySink: CopySink
    ): Promise<AzureBlobStoreWriteSettings> {
        const result = await super._toModel(resource, copySink);
        StoreWriteSettingsAdapter.toStoreWriteSettingsModel(resource, result);
        this._commonPropsToModel(resource, result, copySink);
        return result;
    }
}
